export const DEFAULT_QUERY_LIMIT = 10;
